export { default } from "./exportComponentsToRails";
